import {Popover} from 'antd';
import cn from 'classnames';
import React, {FC} from 'react';

import {TStatisticsDataEntryObject} from 'pages/meta-widget-page/hooks/use-statistics-initialization';

import {IProgressListStatisticsSettings} from '../progress-list-statistics-types';
import {ProgressBar} from './progress-bar';

import './progress-list-item.less';

interface IProgressListItemProps {
    entry: TStatisticsDataEntryObject;
    settings: IProgressListStatisticsSettings;
}

export const ProgressListItem: FC<IProgressListItemProps> = ({entry, settings}: IProgressListItemProps) => {
    const {key, value, label} = entry;
    const {barColor} = settings;

    return (
        <div className={cn('progress-list-statistics__body__item')}>
            <Popover
                content={label}
                placement="right"
                overlayClassName={cn('progress-list-statistics__body__item__popover', {hidden: !label})}
            >
                <div className={cn('progress-list-statistics__body__item__title')}>{key}</div>
            </Popover>

            <ProgressBar
                value={value}
                maximum={100}
                barColor={barColor}
            />
            <div className={cn('progress-list-statistics__body__item__value')}>{value}</div>
        </div>
    );
};
